import { Paper } from "@mui/material";
import Card from "components/Dashboard/Card";

export default function RiskInfo(props) {
  const t = props.risk;
  const data = {
    "Flood Zone": (t.fema_flood_all || []).length
      ? t.fema_flood_all[0].properties.FLD_ZONE
      : undefined,
    "Flood Risk Detail": (t.fema_flood_all || []).length
      ? t.fema_flood_all[0].properties.ZONE_SUBTY
      : undefined,
    "Distance to saltwater": t.distance_to_saltwater
      ? `${Math.round(
          t.distance_to_saltwater * (t.distance_to_saltwater < 1 ? 5280 : 1)
        ).toLocaleString()} ${t.distance_to_saltwater < 1 ? "feet" : "miles"}`
      : undefined,
    "Fire Risk": t.fire_risk,
    "Fire Station Proximity": (t.hifld_fire_stations || []).length
      ? `${t.hifld_fire_stations[0].properties.radius} mile or less`
      : undefined,
    "Fire Station Drive Distance": (t.fire_station_info || {}).distance
      ? `${t.fire_station_info.distance.toFixed(2)} miles`
      : undefined,
    "Fire Station Drive Time": (t.fire_station_info || {}).duration,
    "Hurricane events": (t.noaa_hurricane_energy || []).length
      ? t.noaa_hurricane_energy[0].properties.count
      : undefined,
    "Tornado events": (t.noaa_tornado_energy || []).length
      ? t.noaa_tornado_energy[0].properties.count
      : undefined,
    "Fault Line Proximity": (t.usgs_fault_lines || []).length
      ? `${(
          t.usgs_fault_lines[0].properties.tilequery.distance * 0.000621371192
        ).toFixed(2)} miles`
      : undefined,
    "Shaking Intensity": (t.usgs_seismic_hazard || []).length
      ? `${t.usgs_seismic_hazard[0].properties.ground_acceleration} meters per second`
      : undefined,
    "Perceived Shaking": (t.usgs_seismic_hazard || []).length
      ? `${t.usgs_seismic_hazard[0].properties.perceived_shaking}`
      : undefined,
    "Potential Damage": (t.usgs_seismic_hazard || []).length
      ? `${t.usgs_seismic_hazard[0].properties.potential_damage}`
      : undefined,
    "Eathquake Zone": (t.usgs_seismic_hazard || []).length
      ? `${t.usgs_seismic_hazard[0].properties.instrumental_intensity}`
      : undefined,
  };
  return (
    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <Card label="Risk Info" activeKey="risk_info" row={data} />
    </Paper>
  );
}
